export default __webpack_public_path__ + "static/media/iconToggleGrid.e7b837cd.svg";